import gql from 'graphql-tag'
import { PITCHING_CANDIDATE_FRAGMENT } from '@/components/Contacts/RecruiterFreelancer/oldGraphql/fragments'

/**
 * *** WARNING ***
 * The following is still tinkered to the old API
 */

export const AvailableCandidates = gql`
  query candidates($rateType: RateType!, $currency: String!) {
    me {
      activeAccount {
        globalId
        ... on Recruiter {
          candidates(filter: { availability: AVAILABLE }) {
            data {
              ...PitchingCandidateFragment
            }
          }
        }
      }
    }
  }
  ${PITCHING_CANDIDATE_FRAGMENT}
`
